import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import _ from "lodash";
import { showMessage } from "./common.slice";
import { getSessionData } from "utils/common";

const initialState = {
  bankDetails: {
    startAmountRange: "",
    endAmountRange: "",
    bankName: "",
    bankHolderName: "",
    bankAccountNumber: "",
    bankIFSC: "",
  },
  upiDetails: {
    bankUPI: "",
    bankUPIImage: null,
  },
  bankList: [],
  bankId: 0,
  bankloading: false,
  bankTotalRecords: 0,
  bankDetailsSearchText: "",
  startPageBankInRecords: 1,
  whatsAppNumber: "",
  whatsAppisActive: true,
  whatsAppId: 0,
};

export const updateBankDetails = createAsyncThunk(
  "bankDetails/bankDetails/update",
  (data, { dispatch }) => {
    return new Promise((resolve, reject) => {
      let { userId } = getSessionData();
      let newFinalObject = {};
      newFinalObject.id = Number(data.bankId) || 0;
      newFinalObject.startAmountRange = data.startAmountRange;
      newFinalObject.endAmountRange = data.endAmountRange;
      newFinalObject.bankName = data.bankName;
      newFinalObject.bankHolderName = data.bankHolderName;
      newFinalObject.bankAccountNumber = data.bankAccountNumber;
      newFinalObject.bankUPIImage = data.bankUPIImage || "";
      newFinalObject.bankUPI = data.bankUPI;
      newFinalObject.bankIFSC = data.bankIFSC;
      newFinalObject.userId = userId;
      newFinalObject.CreatedBy = userId;
      axios
        .post("finance/bank-detail/save-bank-detail", newFinalObject)
        .then(({ data }) => {
          if (data.status === 200) {
            dispatch(showMessage({ message: "Details saved successfully !" }));
            resolve(data);
          } else {
            dispatch(showMessage({ message: data.message }));
            reject(data);
          }
        })
        .catch((error) => {
          if (error.response) {
            dispatch(showMessage({ message: error.response.data.message }));
          } else if (error.request) {
            dispatch(showMessage({ message: error.request.message }));
          } else {
            dispatch(showMessage({ message: error.message }));
          }
          reject(error);
        });
    });
  }
);
export const updateWhatsappDetail = createAsyncThunk(
  "whatsappdetail/whatsappdetail/update",
  (data, { dispatch }) => {
    return new Promise((resolve, reject) => {
      let { userId } = getSessionData();
      let newFinalObject = {};
      newFinalObject.id = data.whatsAppId;
      newFinalObject.whatsAppNumber = data.whatsAppNumber;
      newFinalObject.isActive = data.whatsAppisActive == "true" ? true : false;
      newFinalObject.userId = userId;
      newFinalObject.createdBy = userId;
      axios
        .post("finance/whatsapp-detail/save-whatsapp-detail", newFinalObject)
        .then(({ data }) => {
          if (data.status === 200) {
            dispatch(showMessage({ message: "Details saved successfully !" }));
            resolve(data);
          } else {
            dispatch(showMessage({ message: data.message }));
            reject(data);
          }
        })
        .catch((error) => {
          if (error.response) {
            dispatch(showMessage({ message: error.response.data.message }));
          } else if (error.request) {
            dispatch(showMessage({ message: error.request.message }));
          } else {
            dispatch(showMessage({ message: error.message }));
          }
          reject(error);
        });
    });
  }
);
export const getBankDetails = createAsyncThunk(
  "bankDetails/bankDetails/get",
  ({ pageNo = 1, pageSize, appendData, searchText }) => {
    return new Promise((resolve, reject) => {
      let { userId } = getSessionData();
      axios
        .get(
          `finance/bank-detail/get-bank-details/${userId}/${pageNo}/${pageSize}${
            searchText ? `?searchText=${searchText}` : ""
          }`
        )
        .then(({ data }) => {
          if (data.status == 200) {
            resolve({ data: data.data, appendData });
          } else {
            reject(data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);
export const getWhatsappDetail = createAsyncThunk(
  "whatsappdetail/whatsappdetail/get",
  ({ pageNo = 1, pageSize, appendData, searchText }) => {
    return new Promise((resolve, reject) => {
      let { userId } = getSessionData();
      axios
        .get(
          `finance/whatsapp-detail/get-whatsapp-details/${userId}/${pageNo}/${pageSize}${
            searchText ? `?searchText=${searchText}` : ""
          }`
        )
        .then(({ data }) => {
          if (data.status == 200) {
            resolve({ data: data.data, appendData });
          } else {
            reject(data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);
export const changeBankActiveStatus = createAsyncThunk(
  "/bankDetails/statuchange",
  (data, { dispatch }) => {
    return new Promise((resolve, reject) => {
      let { id, isBankActive } = data;
      isBankActive = !isBankActive;
      axios
        .get(`finance/bank-detail/change-bank-active-status/${id}/${isBankActive}`)
        .then(({ data }) => {
          dispatch(
            showMessage({ message: (isBankActive ? "Active" : "De-Active") + " successfully!" })
          );
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);
export const bankSlice = createSlice({
  name: "bankDetails",
  initialState,
  reducers: {
    setBankList: (state, action) => {
      state.bankList = action.payload;
    },
    setBankDetailsSearchText: (state, action) => {
      state.bankDetailsSearchText = action.payload;
    },
    setStartPageBankInRecords: (state, action) => {
      state.startPageBankInRecords = action.payload;
    },
    setBankDetails: (state, action) => {
      const p = action.payload || {};
      // Flat API row OR nested { bankDetails, upiDetails, bankId } (legacy Add click).
      const bank = p.bankDetails && typeof p.bankDetails === "object" ? p.bankDetails : p;
      const upi = p.upiDetails && typeof p.upiDetails === "object" ? p.upiDetails : p;
      const id = Number(p.id ?? p.bankId ?? bank.id ?? 0) || 0;
      state.bankId = id;
      state.bankDetails = {
        startAmountRange: bank.startAmountRange ?? "",
        endAmountRange: bank.endAmountRange ?? "",
        bankName: bank.bankName ?? "",
        bankHolderName: bank.bankHolderName ?? "",
        bankAccountNumber: bank.bankAccountNumber ?? "",
        bankIFSC: bank.bankIFSC ?? "",
      };
      const img = upi.bankUPIImage ?? upi.BankUPIImage ?? null;
      state.upiDetails = {
        bankUPI: upi.bankUPI ?? upi.BankUPI ?? "",
        bankUPIImage: img || null,
      };
    },
    setWhatsAppNumber: (state, action) => {
      state.whatsAppNumber = action.payload;
    },
    setWhatsAppStatus: (state, action) => {
      state.whatsAppisActive = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateBankDetails.pending, (state, action) => {
      state.bankloading = true;
    });

    builder.addCase(updateBankDetails.rejected, (state, action) => {
      state.bankloading = false;
    });

    builder.addCase(updateBankDetails.fulfilled, (state, action) => {
      state.bankloading = false;
    });

    builder.addCase(changeBankActiveStatus.pending, (state, action) => {
      state.bankloading = true;
    });

    builder.addCase(changeBankActiveStatus.rejected, (state, action) => {
      state.bankloading = false;
    });

    builder.addCase(changeBankActiveStatus.fulfilled, (state, action) => {
      state.bankloading = false;
    });

    //get bank details
    builder.addCase(getBankDetails.pending, (state, action) => {
      state.bankloading = true;
    });
    builder.addCase(getBankDetails.rejected, (state, action) => {
      state.bankloading = false;
    });

    builder.addCase(getBankDetails.fulfilled, (state, action) => {
      state.bankloading = false;
      if (action.payload.appendData) {
        state.bankList = [...state.bankList, ...action.payload?.data?.records];
      } else {
        state.bankList = action.payload.data.records;
      }
      state.bankTotalRecords = action.payload.data.totalRecords;
    });

    //get bank details
    builder.addCase(getWhatsappDetail.pending, (state, action) => {
      state.bankloading = true;
    });
    builder.addCase(getWhatsappDetail.rejected, (state, action) => {
      state.bankloading = false;
    });

    builder.addCase(getWhatsappDetail.fulfilled, (state, action) => {
      state.bankloading = false;
      if (action.payload.data.records && action.payload.data.records.length > 0) {
        const { whatsAppNumber, isActive, id } = action.payload.data.records[0];
        state.whatsAppNumber = whatsAppNumber;
        state.whatsAppisActive = isActive;
        state.whatsAppId = id;
      }
    });
  },
});

export const {
  setBankList,
  setBankDetailsSearchText,
  setStartPageBankInRecords,
  setBankDetails,
  bankId,
  setWhatsAppNumber,
  setWhatsAppStatus,
} = bankSlice.actions;

export default bankSlice.reducer;
